module.exports = __webpack_public_path__ + "img/CPT_Logo_2020.8285013c.png";